import { ReactNode } from 'react'

export interface Location {
  id: string
  index: number
}

export interface DragAndDropStatusProps {
  disabled?: boolean
}

export interface IDragAndDropResultProps {
  source: Location
  destination: Location
}

export interface Chunk<ItemType extends DragAndDropStatusProps> {
  id: string
  items: ItemType[]
}

export enum DragAndDropDirection {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export interface IDragAndDropGridProps<ItemType extends DragAndDropStatusProps> {
  items: ItemType[]
  itemsPerLine: number
  direction: DragAndDropDirection

  renderItem(item: ItemType, index: number): ReactNode

  onDragEnd(sourceIndex: number, destinationIndex: number): void
}

export interface IDragAndDropWrapperProps<ItemType extends DragAndDropStatusProps> {
  chunks: Chunk<ItemType>[]
  itemsPerLine: number
  direction: DragAndDropDirection

  render(item: ItemType, index: number): ReactNode

  onDragEnd(result: IDragAndDropResultProps): void
}

export interface IDragAndDropItemProps<ItemType extends DragAndDropStatusProps> {
  item: ItemType
  index: number

  render(item: ItemType, index: number): ReactNode
}
